import {Button} from 'alm-react-components';
import {useTranslation} from 'react-i18next';
import AppleIcon from '../../assets/images/welcome-images/apple-icon.svg';
import GoogleIcon from '../../assets/images/welcome-images/google-icon.svg';
import {socialLogin} from '../../lib/utils';
import { CorporateUser } from '../../assets/constants/constants';
type logTextType = {
  type?: string;
};
const SocialSignBtn = (props: logTextType) => {
  const {t} = useTranslation();
  return (
    <>
      {!CorporateUser && <div className="flex flex-col gap-4">
        <Button
          onClick={() => socialLogin('Google')}
          variant="outline"
          className="w-full space-y-1.5 space-x-1.5 h-auto text-lg py-3 font-normal bg-transparent mb-4"
        >
          <img src={GoogleIcon} className="mr-2 h-6 w-6 me-6" alt="Flowbite Logo" />

          {props.type == 'sign-up' ? t('LogIn.socialLoginGoogle') : t('LogIn.signInWithGoogle')}
        </Button>
        <Button
          onClick={() => socialLogin('Apple')}
          variant="outline"
          className="w-full space-y-1.5 space-x-1.5 h-auto text-lg py-3 font-normal bg-transparent"
        >
          <img src={AppleIcon} className="mr-2 h-6 w-6 me-6" alt="Flowbite Logo" />

          {props.type == 'sign-up' ? t('LogIn.socialLoginApple') : t('LogIn.signInWithApple')}
        </Button>
      </div>}
    </>
  );
};
export default SocialSignBtn;
